import React, { useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';

type UploadProgressSnackbarProps = {
    total: number;
    onMount: (increment: () => void) => void;
};

const UploadProgressSnackbar = function ({ total, onMount }: UploadProgressSnackbarProps) {
    const [count, setCount] = useState(0);
    const onMountRef = useRef(onMount);

    useEffect(() => {
        onMountRef.current(() => setCount((c) => c + 1));
    }, []);

    const suffix = total > 1 ? 's' : '';
    return (
        <Typography>
            {count} / {total} document{suffix} téléchargé{suffix}
        </Typography>
    );
};

export default UploadProgressSnackbar;
